/** Every generation error text takes the same values (most ignore them). */
type GenerationErrorParams = { preference: string; preferences: string };

export const T = {
  en_GB: {
    generatedComposition: "Generated Composition",
    product: "Product",
    weight: "Weight",
    errorNoRiskAssessment: (_p: GenerationErrorParams) =>
      "The portfolio cannot be generated yet: complete the risk assessment first.",
    errorNoDefinition: (_p: GenerationErrorParams) =>
      "The portfolio cannot be generated: no dynamic portfolio is defined for the goal's risk score.",
    errorNoDefinitionForPlatform: (_p: GenerationErrorParams) =>
      "The portfolio cannot be generated: no dynamic portfolio is defined for the goal's platform at this risk score.",
    errorIncompleteDefinition: (_p: GenerationErrorParams) =>
      "The portfolio cannot be generated: the dynamic portfolio for the goal's risk score is not fully set up yet.",
    errorNoProductForPreference: (p: GenerationErrorParams) =>
      `The portfolio cannot be generated: no active product carries the client's preference ${p.preference} on the goal's platform.`,
    errorNoEligibleProductForPreference: (p: GenerationErrorParams) =>
      `The portfolio cannot be generated: the client is not eligible for any product carrying the preference ${p.preference}.`,
    errorSustainabilityNotMatched: (p: GenerationErrorParams) =>
      `Unable to create a portfolio that matches the preferences: ${p.preferences}. Please select another portfolio type or adapt the preferences.`,
    errorGeneric: "The portfolio could not be generated.",
    unsuitableBlocked: (products: string) =>
      `The client is not eligible for ${products} and no product can replace it. The flow cannot be submitted with this portfolio.`,
  },
  nb_NO: {
    generatedComposition: "Generert sammensetning",
    product: "Produkt",
    weight: "Vekt",
    errorNoRiskAssessment: (_p: GenerationErrorParams) =>
      "Porteføljen kan ikke genereres ennå: fullfør risikovurderingen først.",
    errorNoDefinition: (_p: GenerationErrorParams) =>
      "Porteføljen kan ikke genereres: ingen dynamisk portefølje er definert for målets risikoscore.",
    errorNoDefinitionForPlatform: (_p: GenerationErrorParams) =>
      "Porteføljen kan ikke genereres: ingen dynamisk portefølje er definert for målets plattform med denne risikoscoren.",
    errorIncompleteDefinition: (_p: GenerationErrorParams) =>
      "Porteføljen kan ikke genereres: den dynamiske porteføljen for målets risikoscore er ikke ferdig satt opp ennå.",
    errorNoProductForPreference: (p: GenerationErrorParams) =>
      `Porteføljen kan ikke genereres: ingen aktive produkter har klientens preferanse ${p.preference} på målets plattform.`,
    errorNoEligibleProductForPreference: (p: GenerationErrorParams) =>
      `Porteføljen kan ikke genereres: klienten er ikke kvalifisert for noen produkter med preferansen ${p.preference}.`,
    errorSustainabilityNotMatched: (p: GenerationErrorParams) =>
      `Kan ikke lage en portefølje som samsvarer med preferansene: ${p.preferences}. Velg en annen porteføljetype eller juster preferansene.`,
    errorGeneric: "Porteføljen kunne ikke genereres.",
    unsuitableBlocked: (products: string) =>
      `Klienten er ikke kvalifisert for ${products}, og ingen produkter kan erstatte det. Flyten kan ikke sendes inn med denne porteføljen.`,
  },
} as const;
